module.exports = __webpack_public_path__ + "img/2025-0515-01-01.520cf24f.png";